import { Box, Button, Container, ListItemIcon, Menu, MenuItem, Stack } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import Basket from "./Basket";
import { CartItem } from "../../../lib/types/search";
import { useGlobals } from "../../hooks/useGlobal";
import { Logout } from "@mui/icons-material";
import { serverApi } from "../../../lib/config";


interface OtherNavbarProps {
  cartItems: CartItem[];
   onAdd: (item: CartItem) => void;
   onRemove: (item: CartItem) => void;
   onDelete: (item: CartItem) => void;
   onDeleteAll: () => void;
    setSignupOpen: (isOpen: boolean) => void ; 
   setLoginOpen: (isOpen: boolean) =>  void ;
    handleLogoutClick: (e: React.MouseEvent<HTMLElement>) => void;
     anchorEl: HTMLElement | null;
     handleCloseLogout: () => void;
     handleLogoutRequest: () => void;
}
export default function OtherNavbar(props: OtherNavbarProps) {
  const { cartItems , onAdd, onRemove, onDelete, onDeleteAll, setSignupOpen, setLoginOpen, handleLogoutClick,
     anchorEl,
     handleCloseLogout,
     handleLogoutRequest,} = props;
  const {authMember} = useGlobals();
  const location = useLocation();
  const usesLightNavbar =
    location.pathname.startsWith("/products") ||
    location.pathname.startsWith("/help") ||
    location.pathname.startsWith("/orders") ||
    location.pathname.startsWith("/member-page");
  return (
    <div className={`other-navbar${usesLightNavbar ? " products-navbar" : ""}`}>
      <Container className="navbar-container">
        <Stack className="menu">
          <Box className="other-nav-brand">
            <NavLink to="/">
              <img className="brand-logo" src="/icons/logo.png" alt="Logo"/>
            </NavLink>

          </Box>
          <Stack className="links other-nav-center">
            <Box className={"hover-line"}>
              <NavLink to="/">Home</NavLink>
            </Box>
            <Box className={"hover-line"}>
              <NavLink to="/products" activeClassName={"underline"}>Products</NavLink>
            </Box>
            {authMember ? (
              <Box className={"hover-line"}>
                <NavLink to="/orders" activeClassName={"underline"}>Orders</NavLink>
              </Box>
            ) : null}
            {authMember ? (
              <Box className={"hover-line"}>
                <NavLink to="/member-page" activeClassName={"underline"}>My Page</NavLink>
              </Box>
            ) : null}
            <Box className={"hover-line"}>
              <NavLink to="/help" activeClassName={"underline"}>Help</NavLink>
            </Box>
          </Stack>
          <Stack className="other-nav-actions">
            <Basket 
             cartItems={cartItems}
            onAdd={onAdd}
         onRemove={onRemove} 
         onDelete={onDelete} 
         onDeleteAll={onDeleteAll}/>

            {!authMember ? (
              <Box>
                <Button variant="contained" className="login-button"  
                onClick={() => setLoginOpen(true)}>
                  Login
                </Button>
              </Box>
            ) : (
              <img 
               className="user-avatar"
                  src={
                    /* Check if image exists AND is not an empty string */
                    authMember?.memberImage && authMember.memberImage !== ""
                      ? `${serverApi}/${authMember.memberImage}`
                      : "/icons/default-user.svg"
                  }
                  aria-haspopup="true"
                  onClick={handleLogoutClick}
                  alt="user avatar"
              />
            )}

               
            <Menu
            anchorEl={anchorEl}
              id="account-menu"
              open={Boolean(anchorEl)}
              onClose={handleCloseLogout}
              onClick={handleCloseLogout}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleLogoutRequest}>
                <ListItemIcon>
                  <Logout fontSize="small" style={{ color: 'blue' }} />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}